import {
  Button,
  Card,
  Drawer,
  Form,
  Icons,
  Input,
  Select,
  Space,
  Typography,
} from '@pankod/refine-antd';
import { useEffect } from 'react';

export type CustomFieldType = 'Text' | 'Float' | 'Boolean' | 'Dropdown';

export type VariantCustomField = {
  name: string;
  type: CustomFieldType;
  options: string[];
};

export const VariantCustomFieldDrawer = ({
  open,
  customFields,
  onClose,
  onSave,
}: {
  open: boolean;
  customFields: VariantCustomField[];
  onClose: () => void;
  onSave: (customFields: VariantCustomField[]) => void;
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      customFields,
    });
  }, [customFields, form]);

  // const handleCustomFieldTypeChange = (value: CustomFieldType, index: number) => {
  //   if (value !== 'Dropdown')
  //     form.setFields([
  //       {
  //         name: ['customFields', index, 'options'],
  //         value: [],
  //       },
  //     ]);
  // };

  const handleClose = () => {
    onClose();
    form.submit();
  };

  return (
    <Drawer
      title="Add Custom Fields"
      placement="right"
      onClose={handleClose}
      visible={open}
      footer={
        <Button type="primary" onClick={() => form.submit()} style={{ width: '100%' }}>
          Save
        </Button>
      }
    >
      <Form
        form={form}
        layout="vertical"
        scrollToFirstError
        onFinish={(values) => {
          const { customFields } = values;
          onSave(
            (customFields ?? []).map((field: any) => ({
              ...field,
              options: field.options ?? [],
            })),
          );
        }}
      >
        <Form.List name="customFields">
          {(fields, { add, remove }) => {
            // @ts-ignore
            // fields = fields.length === 0 ? [{}] : fields;

            return (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                {fields.map((field, index) => (
                  <Card
                    key={field.key}
                    title={
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <Typography.Text>Custom Field {index + 1}</Typography.Text>
                        <Button
                          type="text"
                          onClick={() => remove(field.name)}
                          icon={<Icons.MinusCircleOutlined />}
                        />
                      </div>
                    }
                  >
                    <Form.Item
                      name={[index, 'name']}
                      label="Name"
                      rules={[
                        {
                          required: true,
                          message: 'Custom field name is required.',
                        },
                      ]}
                    >
                      <Input placeholder="Custom Field name" />
                    </Form.Item>

                    <Form.Item
                      name={[index, 'type']}
                      label="Type"
                      rules={[{ required: true, message: 'Please select a field type.' }]}
                      initialValue={'Text'}
                    >
                      <Select
                        style={{ width: '100%' }}
                        // onChange={(value: CustomFieldType) =>
                        //   handleCustomFieldTypeChange(value, index)
                        // }
                      >
                        <Select.Option key={0} value="Text">
                          <Space align="center">
                            <Icons.FileTextOutlined /> Text
                          </Space>
                        </Select.Option>
                        <Select.Option key={1} value="Float">
                          <Space align="center">
                            <Icons.NumberOutlined /> Number
                          </Space>
                        </Select.Option>
                        <Select.Option key={2} value="Boolean">
                          <Space align="center">
                            <Icons.CheckCircleOutlined /> Boolean
                          </Space>
                        </Select.Option>
                        <Select.Option key={3} value="Dropdown">
                          <Space align="center">
                            <Icons.UnorderedListOutlined /> Dropdown
                          </Space>
                        </Select.Option>
                      </Select>
                    </Form.Item>

                    <Form.Item noStyle shouldUpdate={true}>
                      {({ getFieldValue }) => {
                        const isDropdownType =
                          getFieldValue(['customFields', index, 'type']) === 'Dropdown';

                        return isDropdownType ? (
                          <Form.Item
                            name={[index, 'options']}
                            label="Options"
                            dependencies={[
                              ['customFields', index, 'type'],
                              ['customFields', index, 'name'],
                            ]}
                            rules={[{ required: true, message: 'Please add at least one option.' }]}
                          >
                            <Select
                              mode="tags"
                              options={[]}
                              placeholder="Input your options"
                              getPopupContainer={(triggerNode) => triggerNode.parentElement!}
                              dropdownMatchSelectWidth={false}
                            />
                          </Form.Item>
                        ) : null;
                      }}
                    </Form.Item>
                  </Card>
                ))}

                <Form.Item style={{ marginTop: '1rem' }}>
                  <Button type="dashed" onClick={() => add()} style={{ width: '100%' }}>
                    <Icons.PlusOutlined /> Add field
                  </Button>
                </Form.Item>
              </div>
            );
          }}
        </Form.List>
      </Form>
    </Drawer>
  );
};
